import React, { useState, useEffect, useContext, useRef } from 'react';

import { StoreContext } from 'store';
import { Button } from 'components/Button';
import { Text } from 'components/Text';

import './resultPage.scss';
import { RECOMMENDS_GROUP_ID } from '../consts';
import { SpecialGroup, SpecialGroups, groupItems } from '../helpers/items';
import { LoaderFixed } from 'components/Loaders';

import { RecommendedItems } from 'components/RecommendedItems';
import { Icon } from 'components/Icons';
import { collectItemsByGroups } from '../helpers/items';
import { shopApi } from 'api';
import { trackEvent } from 'analytics/amplitude';

export const Success: React.FC = () => {
  const hasFetchedItemsRef = useRef(false);
  const {
    localisation,
    translation: t,
    location: [country],
  } = useContext(StoreContext);
  const lang = localisation[0] || 'en';

  const [groupedItemList, setGroupedItemList] = useState<SpecialGroups>({});
  const [isLoading, setIsLoading] = useState(true);

  const isPageInIframe = window.self !== window.top;

  useEffect(() => {
    if (!country) {
      return;
    }

    if (hasFetchedItemsRef.current === false) {
      trackEvent('purchase_finished', { status: 'success' });
      setIsLoading(true);
      // to avoid multiple requests
      hasFetchedItemsRef.current = true;
      collectItemsByGroups({ externalId: RECOMMENDS_GROUP_ID, lang, country })
        .then(data => {
          const groupedItems = groupItems(data);
          setGroupedItemList(groupedItems);
        })
        .catch(err => {
          console.error('Failed:', err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [country]);

  const handleItemClick = (item: shopApi.Item) => {
    // Create a message to send

    const message = JSON.stringify({
      message: 'showItem',
      item,
    });

    // Send the message to the parent window
    window.parent.postMessage(message, '*');
  };
  const handleItemPaymentButtonClick = (_: null, item: shopApi.Item) => {
    // Create a message to send
    const message = JSON.stringify({
      message: 'buyItem',
      item,
    });

    // Send the message to the parent window
    window.parent.postMessage(message, '*');
  };
  const handleClick = () => {
    // Create a message to send
    const message = JSON.stringify({
      message: 'closeModal',
    });

    // Send the message to the parent window
    window.parent.postMessage(message, '*');
  };

  const renderButton = () => {
    if (isPageInIframe)
      return (
        <Button
          size="xl"
          Icon={Icon.MarketCart}
          withTriangle
          onClick={handleClick}
          hasMobileSize={true}
        >
          {t.market.resultPage.buttonText.toUpperCase()}
        </Button>
      );

    return (
      <a href={'https://market.tacticool.game'} rel="noreferrer">
        <Button size="xl" Icon={Icon.MarketCart} withTriangle hasMobileSize={true}>
          {t.market.resultPage.buttonText.toUpperCase()}
        </Button>
      </a>
    );
  };

  return (
    <div className="result-page">
      {isLoading && <LoaderFixed />}
      {/* <Button text="Success" onClick={handleClick} /> */}
      <div className="result-page__header">
        <Icon.Success className="result-page__header-icon" />

        <div className="result-page__header-text">
          <Text.HeaderL>{t.market.resultPage.success.title}</Text.HeaderL>
          <Text.HeaderS>{t.market.resultPage.success.subtitle}</Text.HeaderS>
        </div>
      </div>
      <div className="result-page__content">
        <RecommendedItems
          recommendGroups={groupedItemList[RECOMMENDS_GROUP_ID] as SpecialGroup}
          t={t}
          onItemClick={handleItemClick}
          onPaymentClick={handleItemPaymentButtonClick}
        />
      </div>
      <div className="result-page__footer">
        {renderButton()}
        <img
          className="result-page__footer-image"
          src="/img/common/batya_success.webp"
          alt="Succes"
        />
      </div>
    </div>
  );
};
